var _path;
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTypeScript(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 71,
    height: 71,
    viewBox: "0 0 71 71",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M49.5521 55.7461C47.2039 55.5304 44.1901 55.0758 41.2775 51.8949V58.4388C46.6284 61.917 55.8313 61.2786 59.0396 57.0981C60.9463 54.6136 61.7321 51.2855 60.3205 47.5161C56.9941 40.8158 49.0898 40.3997 46.7912 36.1687C44.2517 29.3158 54.7249 28.0776 59.7568 32.6944V26.5429C57.6128 25.1583 54.2038 25.0095 51.8123 25.1387C45.5011 25.4795 41.2601 29.1465 41.3234 34.609C41.0515 42.2341 49.7587 44.1975 54.131 47.7263C57.1004 50.246 56.8878 56.3565 49.5521 55.7461ZM24.6339 60.1162V30.5113H15.0964V25.6157H39.4548V30.5113H29.8974V60.1162L24.6339 60.1162ZM66.5625 4.4375V66.5625H4.4375V4.4375H66.5625ZM71 0H0V71H71V0Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTypeScript);
export default __webpack_public_path__ + "static/media/TypeScript.da1ea364bc85f3096e5b9f1910dee26f.svg";
export { ForwardRef as ReactComponent };